module.exports = __webpack_public_path__ + "img/9.8e6ed055.jpg";